import _ from "lodash";
import { format, parse, getDaysInMonth, isSameMonth } from "date-fns";
import { CalendarLike, Keys } from "./calendar-like";
import Holiday from "@/models/holiday";

const calendar = new CalendarLike();

function holidaysInMonth(holidays: Holiday[], month: Date) {
  return holidays.filter(d => isSameMonth(month, d.date));
}

function parseMonth(y: string, m: string) {
  return parse(`${y}-${m}`, "y-M", new Date());
}

function key(date: Date) {
  return format(date, "yyyy-MM");
}

function mergeHolidays(days: string[], holidays: Holiday[]) {
  holidays.forEach(h => {
    const i = h.date.getDate() - 1;
    days[i] = h.name;
  });
}

function value(holidays: Holiday[], month: Date) {
  const days = new Array(getDaysInMonth(month)).fill("");
  mergeHolidays(days, holidaysInMonth(holidays, month));
  return days;
}

function years(start: Date, end: Date) {
  const keys = Keys(start, end).filter(k => !calendar.hasKey(k));
  return _.uniq(keys.map(k => k.slice(0, 4)));
}

function eachMonth(yyyy: string, fn: (month: Date) => void) {
  for (let m = 1; m <= 12; m++) {
    fn(parseMonth(yyyy, String(m)));
  }
}

async function getDays(
  start: Date,
  end: Date,
  getHolidays: (yyyy: string) => Promise<Holiday[]>
): Promise<string[]> {
  await Promise.all(
    years(start, end).map(async yyyy => {
      const holidays = await getHolidays(yyyy);
      eachMonth(yyyy, month => {
        calendar.append(key(month), value(holidays, month));
      });
    })
  );
  return calendar.get(start, end);
}

export default {
  getDays
};
